import moment from "moment";
import { Box, Divider, Text, VStack } from "native-base";
import React from "react";

import FormButton from "@/components/atoms/FormButton";
import CheckoutResume from "@/components/molecules/CheckoutResume";
import HeaderAddressButton from "@/components/molecules/HeaderAddressButton";
import MobileHeader from "@/components/molecules/MobileHeader";
import Container from "@/components/organisms/Container";

import OrderStatusBadge from "../components/OrderStatusBadge";
import OrderStatusTimeline from "./components/OrderStatusTimeline";
import OrderTrackingLoading from "./components/OrderTrackingLoading";
import { getParsedOrderInfo } from "./functions";
import { OrderTrackingScreenProps } from "./types";

const OrderTrackingMobile = ({
  order,
  hasEvaluation,
  isLoading,
  onGoBack,
  onPressHelpCentral,
  onPressStorePhone,
  openOrderRating,
  openOrderDetails,
}: OrderTrackingScreenProps) => {
  const {
    store,
    items,
    address,
    shipmentValue,
    subtotal,
    total,
    serviceTaxValue,
    voucherDetails,
    separatorName,
    deliverymanName,
    isInProcess,
    isScheduled,
  } = getParsedOrderInfo(order);

  return (
    <Container
      Header={<MobileHeader title="Pedido" subtitle={order?.codigo} onBackPress={onGoBack} />}>
      {isLoading ? (
        <OrderTrackingLoading />
      ) : (
        <VStack mb="32">
          <Box w="full" bgColor="white.50" shadow="4" my="4" p="2" rounded="md">
            <HeaderAddressButton w="100%" defaultAddress={address} showCompletion />
          </Box>
          <CheckoutResume
            store={store}
            itemsQuantity={items?.length}
            shipmentValue={shipmentValue}
            subtotal={subtotal}
            total={total}
            voucherDetails={voucherDetails}
            serviceTaxValue={serviceTaxValue}
          />
          <Box my="4" bgColor="white.50" shadow="4" rounded="md">
            <Box p="4">
              <OrderStatusBadge orderStatus={order?.status} />
            </Box>
            <Box px="4" pb="2">
              <Text fontSize="md" bold>
                {moment(isScheduled ? order?.dataAgendamento : order?.createdAt).format(
                  "DD/MM/YYYY [às] HH:mm"
                )}
              </Text>
              {isScheduled && (
                <Text>
                  Seu pedido foi recebido e ficará ativo quando chegar próximo da hora do seu
                  agendamento!
                </Text>
              )}
              {isInProcess && <Text>Previsão de entrega: de 3 a 4 horas</Text>}
            </Box>
            <Box px="3" p="2">
              {!!separatorName && (
                <Text>
                  <Text bold> Separador: </Text>
                  {separatorName}
                </Text>
              )}
              {!!deliverymanName && (
                <Text>
                  <Text bold> Entregador: </Text>
                  {deliverymanName}
                </Text>
              )}
            </Box>
            {isInProcess && (
              <Box>
                <Divider />
                <Box px="4">
                  <OrderStatusTimeline orderStatus={order?.status} />
                </Box>
              </Box>
            )}
          </Box>
          <FormButton colorScheme="white" textColor="primary.600" onPress={openOrderDetails}>
            Ver detalhes do pedido
          </FormButton>
          {!hasEvaluation && (
            <>
              <Box my="4" mt="8" bgColor="white.50" shadow="4" rounded="md">
                <Text mt="4" fontSize="lg" textAlign="center" bold>
                  Quer ajudar a tornar o iFeira melhor?
                </Text>
                <Text py="2" pb="4" textAlign="center">
                  Avalie nosso serviço e dê sua opnião, é rapidinho!
                </Text>
              </Box>
              <FormButton colorScheme="white" textColor="primary.600" onPress={openOrderRating}>
                Avaliar serviço
              </FormButton>
            </>
          )}
          <Box my="4" mt="8" bgColor="white.50" shadow="4" rounded="md">
            <Text mt="4" fontSize="lg" textAlign="center" bold>
              Houve algum problema com o pedido?
            </Text>
            <Text py="2" pb="4" textAlign="center">
              Entre em contato conosco pela nossa central de ajuda
            </Text>
          </Box>
          <FormButton colorScheme="white" textColor="primary.600" onPress={onPressHelpCentral}>
            Central de ajuda
          </FormButton>
          <FormButton
            colorScheme="white"
            textColor="primary.600"
            mt="4"
            onPress={onPressStorePhone}>
            Fale com o estabelecimento
          </FormButton>
        </VStack>
      )}
    </Container>
  );
};

export default OrderTrackingMobile;
